import { useAppSelector } from '../../../hooks';
import { useEffect, useState } from 'react';
import Loading from '../../../Components/Loading';
import { replaceTradeMark } from '../../../Utility/replaceTradeMark';
import { Card, Row } from 'reactstrap';
import { Clear } from '@mui/icons-material';
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase';

type Product = {
    shimsId: string;
    productName: string;
    filePath: string;
};

const MSDS = () => {
    const token = useAppSelector((state) => state.auth.token)
    const [query, setQuery] = useState<string>('');
    const [ sdsData, setSdsData ] = useState<Product []>([]);
    const [searchData, setSearchData] = useState<Product []>([]);
    const [ apiError, setApiError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(false);

    useEffect(() => {
        getSDS();
    }, []);

    const getSDS = async () => {
        try {
            setLoading(true);
            const sdsUrl = 'https://customer.hirsch.com/sds/v2';
            
            const res = await fetch(sdsUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                }
            });
            const json = await res.json();
    
            if (!json.ack) throw new Error(json.errorMessage);
    
            if (json) {
                setSdsData(json.data);
            }
        } catch (e: any) {
            console.error(e.message);
            setApiError(e.message);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (text: string) => {
        setQuery(text)
        if (text === '') {
            setSearchData(sdsData)
        } else {
            const newSearchData = sdsData.filter(item => 
                item.shimsId.toString().includes(text.toString()) ||
                item.productName.toLowerCase().includes(text.toLowerCase())
            )
            setSearchData(newSearchData)
        }
    };

    const renderItem = ({ item }: { item: Product}) => {

        return (
            <div className='text-start d-flex align-items-center'>
                <a 
                    key={item.shimsId}
                    style={{ textDecoration: 'none', color: 'black', }}
                    href={item.filePath}
                    target='_blank'
                    onClick={() => 
                        logEvent(analytics, 'open_MSDS_web', {
                            name: 'Open MSDS',
                            description: 'User opened MSDS Document'
                    })}
                >
                    <span style={{ fontWeight: 'bold', }}>Item: {item.shimsId} - </span>
                    <span>{replaceTradeMark(item.productName)}</span>
                </a>
            </div>
        );
    };

    return (
        <div className='mx-4'>
            {apiError && 
                <Row>
                    <span style={{ color: 'red', padding: 10 }}>Error: {apiError}</span>
                </Row>
            }
            {loading ? (<Loading />)
            : (
                <>
                    <div
                        style={{
                            position: 'sticky',
                            top: 60,
                            zIndex: 1000,
                            paddingBlock: '10px',
                        }}
                        className='bg-light'
                    >
                        <OutlinedInput 
                            id='search'
                            style={{ width: '75%' }}
                            value={query}
                            className='bg-white shadow-sm'
                            onChange={(e) => handleSearch(e.target.value)}
                            placeholder='Search'
                            endAdornment={
                                <InputAdornment position='end'>
                                    <IconButton
                                        onClick={() => setQuery('')}
                                        edge='end'
                                    >
                                        {query ? <Clear /> : null}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </div>
                    <div className='mx-2'>
                        {(query ? searchData : sdsData).map((item: Product) => (
                            <Card 
                                key={item.shimsId}
                                style={{ minHeight: '3rem', marginBlock: 3, }}
                                className='shadow-sm px-3'
                            >
                                <div>
                                    {renderItem({ item })}
                                </div>
                            </Card>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
};

export default MSDS;